import {connect} from 'react-redux';
import HomeDataStepView from '../../../components/views/mx/creditoReal/HomeDataStepView';
import * as ModalActions from '../../../actions/ModalActions';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import {withRouter} from 'react-router';
import {FormFieldProps} from '../../../../common/types/components';
import {BankTarget} from '../../../types/mx/types';
import * as WizardValidationUtils from '../../../utils/WizardValidationUtils';
import {State} from '../../../types/mx/reducers';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import * as FileTypeConstants from '../../../../common/constants/FileTypeConstants';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';
import {MODAL_TYPE} from '../../../constants/ModalConstants';
import {MX_VALUES} from '../../../constants/MX/WizardInputs';
import * as ValidateConstant from '../../../constants/ValidateConstant';
import {CR_DEPENDENT_CATALOG_ID} from '../../../constants/MotorcreditConstants';
import {billingTypeSelector, taxRegimeSelector} from '../../../selectors/creditoReal/applicantWork';
import {relationshipTypeSelector} from '../../../selectors/creditoReal/applicantHome';

const mapStateToProps = (state: State, {match}) => {
    const applicantHomeState = state.creditoReal.loanApplication.applicantHome;
    const summaryStepView = state.creditoReal.ui.summaryStepView;
    const homeDataStepViewFieldErrorState = state.creditoReal.ui.homeDataStepView.fieldErrors;
    const employment = state.creditoReal.loanApplication.applicantEmployment;
    const workStepViewState = state.creditoReal.ui.workDataStepView.fieldErrors;
    const {catalogs} = state;
    const crHouseTypeCatalog = catalogs.crHouseType;
    const crDocumentTypeCatalog = catalogs.crDocumentType;
    const crBusinessTypeCatalog = catalogs.crBusinessType;
    return {
        crHouseTypeCatalog,
        crBusinessTypeCatalog,
        crDocumentTypeCatalog: crDocumentTypeCatalog.filter(x => x.id !== '0'),
        addressField: new FormFieldProps(
            applicantHomeState.address, homeDataStepViewFieldErrorState.addressFieldError
        ),
        extNumberField: new FormFieldProps(
            applicantHomeState.extNumber, homeDataStepViewFieldErrorState.extNumberFieldError
        ),
        intNumberField: new FormFieldProps(
            applicantHomeState.intNumber, homeDataStepViewFieldErrorState.intNumberFieldError
        ),
        postalCode: applicantHomeState.postalCode,
        postalCodeField: new FormFieldProps(
            applicantHomeState.postalCode, homeDataStepViewFieldErrorState.postalCodeFieldError
        ),
        stateField: new FormFieldProps(
            WizardValidationUtils.getCatalogValue(applicantHomeState.state),
            homeDataStepViewFieldErrorState.stateFieldError
        ),
        cityField: new FormFieldProps(
            WizardValidationUtils.getCatalogValue(applicantHomeState.city),
            homeDataStepViewFieldErrorState.cityFieldError
        ),
        municipalityField: new FormFieldProps(
            WizardValidationUtils.getCatalogValue(applicantHomeState.municipality),
            homeDataStepViewFieldErrorState.municipalityFieldError
        ),
        colonies: applicantHomeState.colonies,
        selectedColonyField: new FormFieldProps(
            applicantHomeState.selectedColony,
            homeDataStepViewFieldErrorState.selectedColonyFieldError
        ),
        phoneField: new FormFieldProps(applicantHomeState.phone, homeDataStepViewFieldErrorState.phoneFieldError),
        hasNotErrorHomeDataFields: WizardValidationUtils.hasNotErrorHomeDataFields(
            homeDataStepViewFieldErrorState.addressFieldError,
            homeDataStepViewFieldErrorState.extNumberFieldError,
            homeDataStepViewFieldErrorState.postalCodeFieldError,
            homeDataStepViewFieldErrorState.stateFieldError,
            homeDataStepViewFieldErrorState.municipalityFieldError,
            homeDataStepViewFieldErrorState.selectedColonyFieldError,
            homeDataStepViewFieldErrorState.phoneFieldError,
            workStepViewState.monthlyIncomesFieldError,
            employment.includeMonthlyIncomes,
            homeDataStepViewFieldErrorState.houseHoldMeasureFieldError,
            homeDataStepViewFieldErrorState.houseHoldTimeFieldError,
            homeDataStepViewFieldErrorState.houseTypeFieldError,
            workStepViewState.documentTypeFieldError,
            workStepViewState.businessTypeFieldError,
            workStepViewState.workingSinceFieldError,
            workStepViewState.billingTypeFieldError,
            workStepViewState.relationshipTypeIdFieldError,
            workStepViewState.taxRegimeFieldError,
        ),
        hasPostalCodeError: state.creditoReal.ui.homeDataStepView.hasPostalCodeError,
        countrySelected: state.countrySelector.countrySelected,
        loanApplicationToken: match.params.token,
        returnToSummary: summaryStepView.returnToSummary,
        booleanOptions: MX_VALUES.BOOLEAN_VALUES,
        includeMonthlyIncomesField: new FormFieldProps(employment.includeMonthlyIncomes),
        monthlyIncomesField: new FormFieldProps(employment.monthlyIncomes,
            workStepViewState.monthlyIncomesFieldError),
        employmentTypes: catalogs.employmentTypes,
        employmentTypesField: new FormFieldProps(relationshipTypeSelector(state), workStepViewState.relationshipTypeIdFieldError),
        lapse: catalogs.lapse,
        houseHoldMeasureSelectedField: new FormFieldProps(
            applicantHomeState.houseHoldMeasure, homeDataStepViewFieldErrorState.houseHoldMeasureFieldError),
        houseHoldTimeSelectedField: new FormFieldProps(applicantHomeState.houseHoldTime,
            homeDataStepViewFieldErrorState.houseHoldTimeFieldError),
        houseTypeSelectedField: new FormFieldProps(applicantHomeState.houseType,
            homeDataStepViewFieldErrorState.houseTypeFieldError),
        documentTypeSelectedField: new FormFieldProps(employment.documentType,
            workStepViewState.documentTypeFieldError),
        businessTypeSelectedField: new FormFieldProps(employment.businessType,
            workStepViewState.businessTypeFieldError),
        workingSinceField: new FormFieldProps(employment.workingSince, workStepViewState.workingSinceFieldError),
        billingTypes: catalogs.employmentBillingTypes,
        billingTypeField: new FormFieldProps(billingTypeSelector(state), workStepViewState.billingTypeFieldError),
        taxRegimes: catalogs.employmentTaxRegimes,
        taxRegimeField: new FormFieldProps(taxRegimeSelector(state), workStepViewState.taxRegimeFieldError),
        billingFiles: state.creditoReal.loanApplication.files.work?.billingFiles || [],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeAddress: (address, error) => {
            dispatch(WizardActions.CHANGE_HOME_ADDRESS_ACTION.action(address, error));
        },
        onChangeExtNumber: (extNumber, error) => {
            dispatch(WizardActions.CHANGE_HOME_EXT_NUMBER_ACTION.action(extNumber, error));
        },
        onChangeIntNumber: (intNumber, error) => {
            dispatch(WizardActions.CHANGE_HOME_INT_NUMBER_ACTION.action(intNumber, error));
        },
        onChangePostalCode: country => (postalCode, error) => {
            dispatch(WizardActions.CHANGE_HOME_POSTAL_CODE_ACTION.action(postalCode, country, error));
        },
        onChangePhone: (postalCode, error) => {
            dispatch(WizardActions.CHANGE_HOME_PHONE_ACTION.action(postalCode, error));
        },
        onChangeColony: (colony, error) => {
            dispatch(WizardActions.CHANGE_HOME_COLONY_MX_ACTION.action(colony, error));
        },
        onPressNext: () => {
            pushDataLayer(DATA_LAYER.HOME);
            dispatch(WizardMXActions.SAVE_EMPLOYMENT_PARTIAL_DATA_MX_ACTION.action());
        },
        onPressBack: () => {
            dispatch(WizardMXActions.GO_TO_APPLICANT_DATA_MX_ACTION.action());
        },
        getLoanApplication: token => () => {
            dispatch(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.action(token));
        },
        onChangeIncludeMonthlyIncomes: monthlyIncomes => (includeMonthlyIncomes) => {
            dispatch(
                WizardActions.CHANGE_INCLUDE_MONTHLY_INCOMES.action(includeMonthlyIncomes.payload, monthlyIncomes)
            );
            dispatch(WizardActions.CHANGE_EMPLOYMENT_DOCUMENT_TYPE_ACTION
                .action(undefined, includeMonthlyIncomes.payload ? ValidateConstant.ERROR_REQUIRED : null));
        },
        onChangeMonthlyIncomes: (monthlyIncomes, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_MONTHLY_INCOMES_ACTION.action(monthlyIncomes, error)),
        onChangeEmploymentTypes: (employmentType, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_TYPES_INCOMES.action(employmentType, error));
            dispatch(WizardActions.CHANGE_EMPLOYMENT_BUSINESS_TYPE_ACTION
                .action(undefined, employmentType.id === CR_DEPENDENT_CATALOG_ID ?
                    null : ValidateConstant.ERROR_REQUIRED));
        },
        onChangeHouseHoldTime: (houseHoldTime, error) => {
            dispatch(WizardActions.CHANGE_HOUSEHOLD_TIME_ACTION.action(houseHoldTime, error));
        },
        onChangeHouseHoldMeasure: (houseHoldMeasure, error) => {
            dispatch(WizardActions.CHANGE_HOUSEHOLD_MEASURE_ACTION.action(houseHoldMeasure, error));
        },
        onChangeHouseType: (houseType, error) => {
            dispatch(WizardActions.CHANGE_HOUSE_TYPE_ACTION.action(houseType, error));
        },
        onChangeDocumentType: (documentType, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_DOCUMENT_TYPE_ACTION.action(documentType, error));
        },
        onChangeBusinessType: (businessType, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_BUSINESS_TYPE_ACTION.action(businessType, error));
        },
        onChangeWorkingSince: (workingSince, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_WORKING_SINCE_ACTION.action(workingSince, error)),
        onChangeBillingType: (billingType, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_BILLING_TYPE_ACTION.action(billingType, error)),
        onChangeTaxRegime: (taxRegime, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_TAX_REGIME_ACTION.action(taxRegime, error)),
        onDropBillingFile: (files, type, section, error) =>
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.CREDITO_REAL_STATE)),
        onDeleteBillingFile: id =>
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.PROOF_OF_TAX_STATUS_TYPE, BankTarget.CREDITO_REAL_STATE
        )),
        onClickBillingFileThumbnail: (item) => {
            const content = {
                type: MODAL_TYPE.SHOW_FILE_IMG_VIEW,
                data: item
            };
            const options = {
                closeOnOverlayClick: true,
                size: 'small'
            };
            dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(null, content, null, options));
        },
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        onChangePostalCode: dispatchProps.onChangePostalCode(stateProps.countrySelected),
        getLoanApplication: dispatchProps.getLoanApplication(stateProps.loanApplicationToken, stateProps.postalCode,
            stateProps.countrySelected),
        booleanOptions: stateProps.booleanOptions.map((item) => {
            if (item.payload) return {...item, defaultChecked: stateProps.monthlyIncomes > 0};
            return {...item, defaultChecked: stateProps.monthlyIncomes === 0};
        }),
        employmentTypes: stateProps.employmentTypes.map((item, index) => {
            return {...item, defaultChecked: index === 0, label: item.value};
        }),
        billingTypes: stateProps.billingTypes.map((item, index) => {
            return {...item, defaultChecked: index === 0, label: item.value};
        }),
        onChangeIncludeMonthlyIncomes: dispatchProps.onChangeIncludeMonthlyIncomes(
            stateProps.monthlyIncomesField.value
        )
    };
};

const HomeDataStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(HomeDataStepView));

export default HomeDataStepContainer;
